// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-YRX","comment":"styles_comment__33CXz"};